// ------------------------------- GLOBAL OBJECTS COMMONLY USED (CSS) --------------------------------------
require('../shared/default.less');
require('../assets/wixrest-icons/wixrest-icons.css');
import 'whatwg-fetch';
import React from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { create as fedopsLoggerCreate } from '@wix/fedops-logger';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as seatingActions } from '../actions/SessionActions';
import { actions as fedopsActions } from '@wix/restaurants-redux/dist/actions/FedopsActions';
import QueryUtils from '@wix/wixrest-utils/dist/QueryUtils';
import WixInstance from '@wix/wixrest-utils/dist/WixInstance';
import FacebookSignedRequest from '@wix/wixrest-utils/dist/FacebookSignedRequest';
import Wss from '@wix/wixrest-utils/dist/Wss';
import ReservationUtils from '@wix/wixrest-utils/dist/openrest-helpers/Reservation';
import HistoryManager from '@wix/wixrest-utils/dist/HistoryManager';
import Utils from '@wix/wixrest-utils/dist/Utils';
import PhoneUtils from '@wix/wixrest-utils/dist/PhoneUtils';
import { Provider }                from 'react-redux';
import createConfiguredStore       from '@wix/restaurants-redux/dist/store/ConfigureReduxStore';
import * as WebInitActions         from '@wix/restaurants-redux/dist/actions/WebInitActions';
import CssProvider from '@wix/restaurants-components-css-modules/dist/web/CssProvider/CssProvider';
import I18nWebProvider from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/I18nWebProvider';
import moment from 'moment-timezone';
import ReactDOM from 'react-dom';
import SeatingAppContainer from './containers/SeatingAppContainer';
import ConfirmationContainer from './containers/ConfirmationContainer';
import NotEnabledMessage from '../shared/components/NotEnabledMessage/NotEnabledMessage';
import I18nify from '@wix/restaurants-components-css-modules/dist/shared/I18nify';
import Premium from '@wix/restaurants-components-css-modules/dist/logic/Premium/index';
import { UpdatablePopup, PopupProvider } from '../shared/components/Popup';
import {BI} from '@wix/wixrest-bi';
import TOKENS from '../tokens';
import fedopsJson from '../../fedops.json';
import wixFullstoryLoader from '@wix/wix-fullstory-loader';
import { hot } from 'react-hot-loader';

wixFullstoryLoader({label: 'restaurants-reservations-web', sample: window.spiceProduction ? 0.02 : 0});
const HEADER = 'reservations_app_';

const PopupProviderComp = connect(state => {
    return {
        wixInstance:state.wixInstance.instance,
        selectedBranchId: null,
        proceedingToBranch: null
    }
})(PopupProvider);

/******** REDUCERS ***********/
const reducers = {
    jointLoginInfo    : require('@wix/restaurants-redux/dist/reducers/JointLoginReducer').default,
    wixInstance       : require('@wix/restaurants-redux/dist/reducers/WixInstanceReducer').default,
    wixInstalledApps  : require('@wix/restaurants-redux/dist/reducers/WixInstalledAppsReducer').default,
    i18nData          : require('@wix/restaurants-redux/dist/sagas/I18nSaga').default.reducer,
    organization      : require('@wix/restaurants-redux/dist/reducers/OrganizationReducer').default,
    styles            : require('@wix/restaurants-redux/dist/reducers/StylesReducer').default,
    seatingSettings   : require('./../reducers/SettingsReducer').default,
    seatingSession    : require('./../reducers/SessionReducer').default,
    seatingForm       : require('./../reducers/FormReducer').default,
    locations         : require('@wix/restaurants-redux/dist/reducers/LocationsReducer').default,
};

/******** SAGAS ***********/
const sagas = [
    require('@wix/restaurants-redux/dist/sagas/OrganizationSaga').default,
    require('@wix/restaurants-redux/dist/sagas/JointLoginSaga').default,
    require('@wix/restaurants-redux/dist/sagas/WebInitSaga').default,
    require('@wix/restaurants-redux/dist/sagas/WixInstalledAppsSaga').default,
    require('@wix/restaurants-redux/dist/sagas/FeedbackSaga').default,
    require('@wix/wixrest-bi').redux.Saga,
    require('@wix/restaurants-redux/dist/sagas/WixStylesSaga').default,
    require('@wix/restaurants-redux/dist/sagas/HistoryManagerSaga').default,
    require('../sagas/SettingsSaga').default,
    require('../sagas/SessionSaga').default,
    require('../sagas/FormSaga').default,
    require('@wix/restaurants-redux/dist/sagas/FedopsSaga').default,
    require('@wix/restaurants-redux/dist/sagas/I18nSaga').default.saga,
    require('@wix/restaurants-redux/dist/sagas/LocationsSaga').default,
];

/******** SAGA PARAMS ***********/
import { WixApi }               from '@wix/wixrest-wix-api';
import { v4 as uuid }           from 'uuid';
import Q                        from 'q';
import ReservationValidator     from '../shared/utils/ReservationValidator';
import { clients } from 'wix-restaurants-js-sdk';

const queryHash = QueryUtils.buildQueryHash();

const WIX_APP_IDS    = WixInstance.getAllAppIds();
const wixApi         = new WixApi({wixRestAppIds : WIX_APP_IDS});
const FB             = window.FB;
const Wix            = window.Wix;
import OpenrestService          from 'openrest';

const css = _.map($('style'), (style) => $(style).text().replace(/\s+px/g, 'px').split('\n').join(' ')).join(' ');
const wss = window.wssSerialize ? new Wss(window.wssSerialize) : new Wss({css});
const fedopsLogger = fedopsLoggerCreate(fedopsJson['app_name']);

const sagaParams = {
    OpenrestService,
    restClient: clients.createRestClient({timeout:0}),
    mappingClient: clients.createRestClient({timeout:0, baseUrl: 'https://mapping.wixrestaurants.com/v1'}),
    authentication: clients.createRestClient({timeout:0, baseUrl: 'https://auth.wixrestaurants.com/v2'}),
    WIX_APP_IDS,
    wixApi,
    FB,
    fetch,
    Wix,
    WixInstance,
    uuid,
    window,
    Q,
    wss,
    $,
    Premium,
    ReservationValidator,
    ReservationUtils,
    moment,
    HistoryManager,
    PhoneUtils,
    Utils,
    fedopsLogger,
    fedopsJson
};

const initialState = _.isEmpty(window.__INITIAL_STATE__) ? undefined : window.__INITIAL_STATE__;
const confStore = {
    reducers,
    sagas,
    sagaParams,
    middlewares:[],
    useLogger: false//!window.spiceProduction
};

if (initialState) {
    confStore.initialState = initialState;
}

const store = createConfiguredStore(confStore);

function mapStateToProps(state) {
    return {
        organization: state.organization.organization,
        styles: state.styles.styles,
        i18nData: state.i18nData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        seatingActions: bindActionCreators(seatingActions, dispatch),
        fedopsActions: bindActionCreators(fedopsActions, dispatch)
    };
}

const PopupWrapper = I18nify(class extends React.Component {
    componentWillMount() {
        this._updateBodyClasses();
    }

    componentWillReceiveProps() {
        this._updateBodyClasses();
    }

    render() {
        return this.props.children;
    }

    _updateBodyClasses = () => {
        const { i18n } = this.props;
        const dir = i18n._i18n.dir;
        $(document.body).removeClass('ltr rtl');
        $(document.body).addClass(dir);
        $(document.body).attr('direction', dir);
        $(document.body).css('direction', dir);
        $(document.body).css('padding', '0px');
        $(document.body).css('margin', '0px');
    };
});

const reportFirstRender = _.once(() => {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
        performance.mark('[perfer] app-loaded');
    }
});

const SeatingApp = connect(mapStateToProps, mapDispatchToProps)(class extends React.Component {
    state = {
        removedLoader: false
    };

    componentWillMount() {
        this._setLoaderStateIfNeeded();
    }

    componentWillUpdate(nextProps) {
        this._setLoaderStateIfNeeded(nextProps);
    }

    componentDidMount() {
        const { removedLoader } = this.state;
        const { fedopsActions } = this.props;

        fedopsActions.appLoaded();
        reportFirstRender();

        if (removedLoader) {
            this._removePreloader();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.removedLoader && this.state.removedLoader) {
            this._removePreloader();
        }
    }

    render() {
        const { organization, styles, i18nData } = this.props;
        const notHasOrganization = _.isEmpty(organization) || _.isEmpty(styles);
        const dir = i18nData.localeData.dir;

        $(document.body).removeClass('ltr rtl');
        $(document.body).addClass(dir);
        $(document.body).attr('dir', dir);
        $(document.body).css('direction', dir);
        $(document.body).css('padding', '0px');
        $(document.body).css('margin', '0px');

        const compId = typeof Wix !== 'undefined' ? Wix.Utils.getCompId() : '';

        return notHasOrganization ? <div></div> : <SeatingAppContainer compId={compId}/>;
    }

    _removePreloader = () => {
        $('.__preloader').remove();
    };

    _setLoaderStateIfNeeded = (props) => {
        const { organization, styles } = props || this.props;
        const hasOrganization = !_.isEmpty(organization) && !_.isEmpty(styles);

        if (!this.state.removedLoader && hasOrganization) {
            this.setState({removedLoader: true});
        }
    };
});

const I18nWebProviderConnected = connect(function (state) {
    return {localeData: state.i18nData.localeData};
})(I18nWebProvider);
const CssProviderI18nified = I18nify(CssProvider);

function start() {
    window.openrest = require('openrest'); // For debugging
    window.WixInstance = WixInstance;
    sendLoadingBiEvent();

    if (Wix && Wix.Performance) {
        Wix.Performance.applicationLoadingStep(1, `onStart-${queryHash.type}`);
    }
    moment.relativeTimeThreshold('m', 10000); // No threshold to show minutes

    document.body.style.backgroundColor = 'transparent';

    window.START_APP_TIME = (new Date()).getTime();
    console.log('[Performance] Start app time', window.START_APP_TIME - window.LOAD_TIME);

    let facebookPageId = null;

    if (queryHash.facebookSignedRequest) {
        FacebookSignedRequest.init(queryHash.facebookSignedRequest);
        facebookPageId = FacebookSignedRequest.getPageId();
    }

    // Should we force a specific restaurant?
    let forceId = (() => {
        let paths = window.location.pathname.split('/');
        return (paths.length > 2) && (paths[1] === 'force') ? paths[2] : queryHash.organizationId;
    })();

    //const useMultiLocationFromSSR = _.get(initialState, 'useMultilocation');
    // if ssr was renderer - useMultiLocationFromSSR will be true / false. o.w- it will be undefined, and then we handle it as true
    //const isMultiLocationExperiment = typeof useMultiLocationFromSSR === 'boolean' ? useMultiLocationFromSSR : true;

    store.dispatch(WebInitActions.actions.initWeb({i18nUxMode: false, queryHash,
        appId: WixInstance.SEATING_APP_ID, system: 'client', forceId, facebookPageId, useMultilocation: true}));

    const POPUP_TYPE = 'popup-web-seating';
    const type = (() => {
        if (queryHash.type === POPUP_TYPE) {
            return POPUP_TYPE;
        } else if (queryHash.type === 'wixseating.client') {
            return 'wix-seating';
        }
        return queryHash.type;
    })();
    const isPopup = (type === POPUP_TYPE);

    if (isPopup) {
        popupApp();
    } else {
        $('html').css({height: '100%', 'min-height':'100%'});
        $('body').css({height: '100%'});
        $('#mainDiv').css({height: '100%'});

        const rootInstance = hot(module)(ReactDOM.render(
            <Provider store={store}>
                <I18nWebProviderConnected appHeader={HEADER} appTokens={TOKENS} Intl={Intl}>
                    <PopupProviderComp type={POPUP_TYPE}>
                        <CssProviderI18nified wss={wss}>
                            <SeatingApp />
                        </CssProviderI18nified>
                    </PopupProviderComp>
                </I18nWebProviderConnected>
            </Provider>,
            document.getElementById('mainDiv')));
    }
}

function popupApp () {
    //added visibility hidden when popup is closed => accessibility : user could tab to the form in the popup
    $('body').css({ margin:'0px', height:'100%', width:'100%', visibility:'hidden' });
    $('html').css({ margin:'0px', height:'100%', width:'100%' });
    $('.__preloader').remove();

    const uniqueId = queryHash.uniqueId;

    var onClose = (data) => {
        Wix.PubSub.publish(uniqueId + 'closing', data);
    };

    var onSave = (data) => {
        Wix.PubSub.publish(uniqueId + 'saving', data);
    };

    var onUpdate = (data) => {
        Wix.PubSub.publish(uniqueId + 'update', data);
    };

    var onPublish = (data) => {
        Wix.PubSub.publish(uniqueId + 'publish', data);
    };

    Wix.PubSub.subscribe(uniqueId + 'open', ({data}) => {
        $('body').css({visibility:'visible' });

        console.log('[Popup.html]', data);
        Wix.resizeWindow('100%', '100%');
        switch (data.type) {
            case 'details': onPopup(ConfirmationContainer, { data, onClose, onSave, onUpdate, onPublish }); break;
            case 'notEnabled': onPopup(NotEnabledMessage, { data, onClose, onPublish }); break;
        }
    });

    Wix.PubSub.subscribe(uniqueId + 'close', () => {
        $('body').css({visibility:'hidden' });

        setTimeout(() => { // clean the DOM
            Wix.resizeWindow('0%', '0%');
            let rootInstance = hot(module)(ReactDOM.render(
                <Provider store={store}>
                    <I18nWebProviderConnected appHeader={HEADER} appTokens={TOKENS} Intl={Intl}>
                        <div></div>
                    </I18nWebProviderConnected>
                </Provider>, document.querySelector('.mainDiv')));
        }, 500);
    });

    Wix.PubSub.subscribe('popupsdestroy', () => {
        console.log('[Popup.html] Destroying', uniqueId);
        Wix.closeWindow();
    });

    Wix.PubSub.publish(uniqueId + 'listening');

    console.log('[Popup.html] Listening', uniqueId);

    sendLoadingBiEvent();
}

function onPopup (element, {data, onClose, onSave, onUpdate, onPublish}) {
    const rootInstance = hot(module)(ReactDOM.render(
        <Provider store={store}>
            <I18nWebProviderConnected appHeader={HEADER} appTokens={TOKENS} Intl={Intl}>
                <CssProviderI18nified wss={wss}>
                    <PopupWrapper>
                        <UpdatablePopup
                            onClose={onClose}
                            onSave={onSave}
                            onUpdate={onUpdate}
                            onPublish={onPublish}
                            outerProps={data}
                            element={element}/>
                    </PopupWrapper>
                </CssProviderI18nified>
            </I18nWebProviderConnected>
        </Provider>, document.querySelector('.mainDiv')));
}

function sendLoadingBiEvent (time = -1) {
    let visitorId = '';
    let loadingTime = time;

    if (loadingTime === -1) {
        try {
            loadingTime = Math.ceil(window.performance.now());
        } catch (e) {}
    }

    try {
        visitorId = window.WixInstance.getVisitorId();
    } catch (e) {}

    BI.event(BI.EVENTS.LIVE_SITE_MENU_LOAD, {
        is_server_side_rendering: true,
        loading_time: loadingTime,
        product: queryHash.type,
        visitorId
    }).catch(() => {
        const state = store.getState();
        const wixInstance = _.get(state, 'wixInstance.instance', {});
        const organization = _.get(state, 'organization.organization', {});

        setTimeout(() => {
            try {
                BI.init({
                    organizationId: organization.id,
                    useIframeLogger: true,
                    metasiteId: wixInstance.getMetasiteId(),
                    biToken: wixInstance.getBiToken(),
                    instanceId: wixInstance.getInstanceId(),
                    ownerId: wixInstance.getSiteOwnerId(),
                    roles: wixInstance.getPermissions() || ''
                });
            } catch (e) {}

            sendLoadingBiEvent(loadingTime);
        }, 300);
    });
}

start();
